import * as Styled from './WithHighlight.styled';

import type { WithHighlightProps } from './WithHighlight.typed';

function WithHighlight(props: WithHighlightProps) {
  const { children, highlight, highlightText, isGrid, className } = props;

  return (
    <Styled.Container
      highlight={highlight}
      isGrid={isGrid}
      className={className}
    >
      {highlight && highlightText && (
        <Styled.Highlight highlight={highlight}>
          {highlightText}
        </Styled.Highlight>
      )}
      {children}
    </Styled.Container>
  );
}

export { WithHighlight };
